export default __webpack_public_path__ + "static/media/repairserviceBG3.899a5967.webp";